module.exports = __webpack_public_path__ + "img/hookup-logo.cf2789f7.png";